export * from './lib/preferences-feature-shell.module';
